import gsap from 'gsap';

class BfvFontObfuscation {
  constructor(options = {}) {
    this.$root = options.element;
    this.$textContainers = this.$root.querySelectorAll('.js-bfv-obfuscated');
    this.fontReplaceElements = [];
    this.fontUrls = {};
  }

  init() {
    this.getFontUrls();
  }

  /**
   * get fonts from data-attributes of text containers
   */
  getFontUrls() {
    [...this.$textContainers].forEach(($textContainer) => {
      if ($textContainer.dataset) {
        const fontUrlString = $textContainer.dataset.fontUrl;
        const fontClassName = $textContainer.dataset.className;

        if (this.fontReplaceElements.indexOf(fontUrlString) === -1) {
          this.fontUrls[fontUrlString] = true;
          this.fontReplaceElements.push({ url: fontUrlString, elem: $textContainer, className: fontClassName });
        }
      }
    });

    this.loadFonts();
    this.assignFonts();
  }

  /**
   * load fonts dynamically, create links to the CSS file in the head
   * an add the classes to the elemets to load obfuscated font
   */
  loadFonts() {
    const head = document.getElementsByTagName('head')[0];

    Object.keys(this.fontUrls)
      .filter((fontUrl) => (
        !head.querySelector(`[href*="${fontUrl}"]`)
      ))
      .forEach((fontUrl) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = `${window.location.protocol}${fontUrl}`;

        head.appendChild(link);
      });
  }

  /**
   * animates fonts to visibility after fonts are loaded
   */
  assignFonts() {
    [...this.fontReplaceElements].forEach((fontObj) => {
      // clone node and hide it to get width change on font loaded
      fontObj.elem.classList.add(fontObj.className);
      const clone = fontObj.elem.cloneNode(true);
      clone.classList.remove('js-bfv-obfuscated');
      clone.classList.remove(fontObj.className);
      clone.classList.add('bfv-obvuscated-hidden');
      clone.removeAttribute('data-font-url');
      if (this.$root.querySelectorAll('.bfv-obvuscated-hidden').length < 1) {
        this.$root.appendChild(clone);
      }

      // intervall to check width of elements and clones of elements to get a "visual callback" on font loaded
      let timesRun = 0;
      const waitForFont = setInterval(() => {
        timesRun += 1;
        if (clone.clientWidth !== fontObj.elem.clientWidth) {
          clearInterval(waitForFont);
          gsap.to(fontObj.elem, 0.3, { autoAlpha: 1 });
        }
        if (timesRun === 3) {
          clearInterval(waitForFont);
          gsap.to(fontObj.elem, 0.3, { autoAlpha: 1 });
          console.warn('canceled interval because of obfuscated font causes no changes');
        }
      }, 300);
    });
  }
}

export default BfvFontObfuscation;
